<div class="container">
    <div id="ProductCatalogDiv" class="row Product-Catalog-Div-cls">
        <div class="col-xs-12 col-md-12">
            <div class="row row-20">
                <div class="col-xs-12 col-sm-6">
                    <div class="label-product-catlog" *ngIf="baseSiteId=='vax' else vsh">VaxServe Vital Solutions</div>
                    <ng-template #vsh>
                        <div class="label-product-catlog">Product Catalog</div>

                    </ng-template>

                </div>
                <div class="col-sm-6 show-all-div-desktop" *ngIf="baseSiteId=='vsh'">
                    <a href="{{categoryURL}}" class="show-all-anchor" data-di-id="di-id-6442ccda-aca14da5">
                        Shop All
                        <img src="../assets/icons/tools-resource-right-arrow.svg" alt="Shop All">
                    </a>
                </div>

                <ngu-carousel #myCarousel [inputs]="carouselConfig" [dataSource]="categoryList">
                    <div *nguCarouselDef="let item;" class="{{baseSiteId}} slide item slider-column">
                        <div class="carousel-item-div">
                            <div class="img-div">
                                <a href={{item.url}} class="image-anchor" data-di-id="di-id-9d79d576-917ed9ac">
                                    <img *ngIf="item.image != null" [src]="getImage(item.image)" alt="img">
                                    <img *ngIf="item.image == null" [src]="fallbackImage" alt="img"
                                        class="flu-poster img_loaded">
                                </a>
                            </div>
                            <div class="label-product-heading">
                                <a href="{{item.url}}" class="heading-anchor" data-di-id="di-id-9d79d576-917ed9ac">
                                    {{item.name}}
                                </a>
                            </div>
                            <div class="label-product-description" [innerHTML]="item.description">

                            </div>
                            <div class="Browse-btn-div">
                                <!--  [routerLink]="[item.url]" -->
                                <a class="Browse-btn-anchor"  href="javascript:void(0)" (click)="navigate(item.url)"
                                    title="Browse" data-di-id="di-id-9d79d576-917ed9ac">
                                    <button *ngIf="baseSiteId=='vax' else vshBtn" type="submit"
                                        class="btn btn-primary">Learn more</button>
                                    <ng-template #vshBtn>
                                        <button type="submit" class="rebr-btn-primary btn Browse-btn"> Browse</button>
                                    </ng-template>
                                </a>
                            </div>
                        </div>
                    </div>
                    <button NguCarouselNext class="rightRs {{baseSiteId}}"
                        [style.opacity]="myCarousel.isLast ? 0.5:1"></button>
                    <button NguCarouselPrev class="leftRs {{baseSiteId}}"
                        [style.opacity]="myCarousel.isFirst ? 0.5:1"></button>
                </ngu-carousel>
                <div class="show-all-div-mobile">
                    <a href="javascript:void(0)" (click)="navigateToPdp()" class="show-all-anchor"
                        data-di-id="di-id-6442ccda-aca14da5">
                        Shop All
                        <img src="../assets/icons/tools-resource-right-arrow.svg" alt="">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>